var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:_vm.classList,attrs:{"title":_vm.tooltip}},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.icon]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }